import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=2fdb42e0&scoped=true"
import script from "./TopPage.vue?vue&type=script&lang=ts"
export * from "./TopPage.vue?vue&type=script&lang=ts"
import style0 from "./TopPage.vue?vue&type=style&index=0&id=2fdb42e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb42e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdb42e0')) {
      api.createRecord('2fdb42e0', component.options)
    } else {
      api.reload('2fdb42e0', component.options)
    }
    module.hot.accept("./TopPage.vue?vue&type=template&id=2fdb42e0&scoped=true", function () {
      api.rerender('2fdb42e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TopPage.vue"
export default component.exports